/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        var hash = document.location.hash;
        var prefix = "view_";
        if (hash) {
          jQuery('.nav-tabs a[href="'+hash.replace(prefix,"")+'"]').tab('show');
        }

        // Change hash for page-reload
        jQuery('.nav-tabs a').on('shown.bs.tab', function (e) {
          window.location.hash = e.target.hash.replace("#", "#" + prefix);
        });

        jQuery(".edit-trigger").on("click", function() {
          var selector = jQuery(this).attr('id');
          jQuery(this).hide();
          jQuery('#'+selector+'-data').hide();
          jQuery('#'+selector+'-form').show();
        });

        jQuery(".edit-cancel").on("click", function() {
          var selector = jQuery(this).attr('id');
          selector = selector.replace('-cancel','');
          jQuery('#'+selector+'-form').hide();
          jQuery('#'+selector+'-data').show();
          jQuery('#'+selector).show();
        });

        jQuery(".ajax-form").submit(function(event) {
          var selector = jQuery(this).attr('id');
          selector = selector.replace('-form','');
          jQuery('#'+selector+'-submit').html('<i class="fa fa-refresh fa-spin"></i> Saving...');
          event.preventDefault();
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    // Login page
    'login': {
      init: function() {
        jQuery("#wp-submit").click(function() {
          var user = jQuery("input#loginemail").val();
          var pass = jQuery("input#loginpassword").val();
          if (user === "") {
            jQuery("input#loginemail").focus();
            return false;
          }
          if (pass === "") {
            jQuery("input#loginpassword").focus();
            return false;
          }
        });
      }
    },
    // Forgot password page
    'forgot_password': {
      init: function() {

        // for lost password
        jQuery("form#lostPasswordForm").submit(function(){
          var submit    = jQuery("div#lostPassword #submit"),
              preloader = jQuery("div#lostPassword #preloader"),
              message   = jQuery("div#lostPassword #message"),
              contents  = {
                action:       'lost_pass',
                nonce:        this.hc_user_lost_password_nonce.value,
                user_login:   this.user_login.value
              };

          // disable button onsubmit to avoid double submision
          submit.attr("disabled", "disabled").addClass('disabled');

          // Display our pre-loading
          preloader.css({'visibility':'visible'});

          jQuery.post( theme_ajax.url, contents, function( data ){
            submit.removeAttr("disabled").removeClass('disabled');

            // hide pre-loader
            preloader.css({'visibility':'hidden'});

            // display return data
            message.html( data );
          });

          return false;
        });


        // for reset password
        jQuery("form#resetPasswordForm").submit(function(){
          var submit    = jQuery("div#resetPassword #submit"),
              preloader = jQuery("div#resetPassword #preloader"),
              message   = jQuery("div#resetPassword #message"),
              contents  = {
                action:       'reset_pass',
                nonce:        this.hc_user_reset_password_nonce.value,
                pass1:        this.pass1.value,
                pass2:        this.pass2.value,
                user_key:     this.user_key.value,
                user_login:   this.user_login.value
              };

          // disable button onsubmit to avoid double submision
          submit.attr("disabled", "disabled").addClass('disabled');

          // Display our pre-loading
          preloader.css({'visibility':'visible'});

          jQuery.post( theme_ajax.url, contents, function( data ){
            submit.removeAttr("disabled").removeClass('disabled');

            // hide pre-loader
            preloader.css({'visibility':'hidden'});

            // display return data
            message.html( data );
          });

          return false;
        });

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


